import Swiper from 'swiper';
import { Pagination } from 'swiper/modules'
import 'swiper/css';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', function () {
    const swipers = document.querySelectorAll('.productsSwiper');
    
    swipers.forEach(swiperEl => {
        new Swiper(swiperEl, {
            modules: [Pagination],
            pagination: {
                el: swiperEl.querySelector('.swiper-pagination'),
                clickable: true,
            },
            spaceBetween: 20,
            loop: true,
        })
    })
})